import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import './BookingForm.css';
import { type } from '@testing-library/user-event/dist/type';

const BookingForm = ({ selectedDate, selectedTime }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const urlSubscription = searchParams.get("subscription");
  const urlPlan = searchParams.get("plan");
  const treatment = searchParams.get("treatment");

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subscription: '',
    plan: '',
  });

  // 🟢 Plans Data
  const plans1 = [
    {
      id: 1,
      name: 'Short-Term Program',
      price: '₹999',
      description: 'Achieve Lasting Health',
      details: [
        "A diet plan for a week created by senior nutritionists at D'Organics",
        'Private access to educational material based on recent research',
        '15 Restaurant guides',
        'Dessert and emotional cleansing guides',
      ],
    },
  ];

  const plans2 = [
    {
      id: 1,
      name: 'One Time Correction Plan',
      price: '₹699',
      description: [
        'Customized 1 diet plan',
        'Specific health guide',
        '1 phone consultation',
        '1 follow-up',
      ],
    },
    {
      id: 2,
      name: 'Monthly Nutrition Plan',
      price: '₹6,000',
      description: [
        'Customized meal plans',
        'Detailed nutritional assessment',
        'All 10 program featured guides',
        'Unlimited WhatsApp support',
        'Blood work analysis',
        'Regular follow-ups',
      ],
    },
    {
      id: 3,
      name: '3-Month Plan',
      price: '₹15,000',
      description: [
        'Customized meal plans',
        'Detailed nutritional assessment',
        'All 10 program featured guides',
        'Blood work analysis',
        'Regular follow-ups',
        'Unlimited WhatsApp support',
      ],
    },
    {
      id: 4,
      name: 'Six-Month Lifestyle Overhaul',
      price: '₹24,000',
      description: [
        'Customized meal plans',
        'Detailed nutritional assessment',
        'All 10 program featured guides',
        'Blood work analysis',
        'Regular follow-ups',
        'Unlimited WhatsApp support',
      ],
    },
  ];

  // 🟢 Inject URL params into state on first load (THIS WAS MISSING IN YOUR CODE)
  useEffect(() => {
    if (urlSubscription && urlPlan) {
      setFormData((prev) => ({
        ...prev,
        subscription: urlSubscription,
        plan: urlPlan,
        treatment: treatment || '',
      }));
    }
  }, [urlSubscription, urlPlan, treatment]);

  // Input handler (clean version)
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // 🔥 FIXED SUBMIT LOGIC (Production Safe)
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!urlSubscription || !urlPlan) {
      alert("Plan information missing. Please select a program again.");
      return;
    }

    handlePlanSelection(urlPlan, urlSubscription, treatment);
  };

  const handlePlanSelection = async (planId, subscription, treatment) => {
    if (!formData.name || !formData.phone || !formData.email) {
      alert('Please fill all required fields.');
      return;
    }

    const plans = subscription === "1" ? plans1 : plans2;
    const selectedPlan = plans.find(
      item => item.id === Number(planId)
    );

    if (!selectedPlan) {
      alert("Invalid plan selected.");
      return;
    }

    try {
      const amountValue = parseInt(
        selectedPlan.price.replace(/[₹,]/g, ''),
        10
      );
      const paymentData = {
        transactionId: `TX_${Date.now()}`,
        MUID: formData.email.split('@')[0] || 'user',
        name: formData.name,
        amount: amountValue,
        number: formData.phone,
        email: formData.email,
        treatment: treatment || "N/A",
        subscriptionDetails: selectedPlan,
      };

      const response = await axios.post(
        'https://54n24jytpd.execute-api.ap-south-1.amazonaws.com/prod/order',
        paymentData
      );

      const paymentUrl =
        response?.data?.data?.instrumentResponse?.redirectInfo?.url;

      if (response?.data?.success && paymentUrl) {
        window.location.href = paymentUrl;
      } else {
        throw new Error('Payment URL not received from server');
      }
    } catch (error) {
      console.error('Payment error:', error);
      alert('Payment failed. Please try again.');
    }
  };

  return (
    <div className="booking-form-container">
      <h2>You are booking: Consultation Phone Call</h2>
      <p>{`${selectedDate || ''} ${selectedTime || ''}`}</p>

      <form onSubmit={handleSubmit}>
        <label>
          Name*
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
        </label>

        <label>
          Email*
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </label>

        <label>
          Phone*
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            required
          />
        </label>

        <button type="submit" className="submit-button">
          Continue 
        </button>
      </form>
    </div>
  );
};

export default BookingForm;